<template>
  <div>
    <div :class="'transcriptContainer'+(data.isDesktopOverlay?' isDesktopOverlay':'')" ref="transcriptContainer">
    <div v-if="!data.isDesktopOverlay" class="headerText">{{$t('Transcript')}}</div>
      <div class="p3sdk-target" :id="divID"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import "../scss/transcriptContent.css";
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    var elem = document.createElement("div");
    elem.innerHTML = this.data.tags;
    var scriptUrl = new URL(elem.querySelector("script").src);
    this.divID = scriptUrl.searchParams.get("target");
    scriptUrl.searchParams.set("video_target", 'video-'+this.initialPrefs.videoID);
    var scriptElem = document.createElement("script");
    scriptElem.src = scriptUrl;
    this.$refs.transcriptContainer.appendChild(scriptElem);
  },
  data() {
    return {
      divID: null,
      style:""
    };
  },
  methods: {
    runFirstLoad() {
    },
    displayDesktopTranscript(){
      if(this.$parent.saveScrollState!=null){
        this.scrollSaveCount = this.$parent.saveScrollState(this);
      }
      if(!this.data.isDesktopOverlay){
        if(this.initialPrefs.showDesktopTranscript){
          Vue.set(this.initialPrefs,'showDesktopTranscript',false)
        }
        else{
          Vue.set(this.initialPrefs,'showDesktopTranscript',true)
        }
      }
    }
  },
  created(){
    window.addEventListener("transcriptDisplayEvent",this.displayDesktopTranscript)
  }
};
</script>